import { Injectable, TemplateRef, ViewChild, ViewContainerRef } from "@angular/core";
import { Router } from "@angular/router";
import { LocalStorageService } from "../services/local-storage.service";
import { EmisorService } from "../services/emisor.service";
import { TokenStorageService } from "../services/token-storage.service";
import { NotificationService } from "../services/notification.service";
import Swal from "sweetalert2";
import { Emisor } from "../models/Emisor/Emisor";
import { ReplaySubject, Subject } from "rxjs";
import { RoleGuard } from "../modules/auth/_services/role.guard";
import { VerificacionCertificadoService } from "./verificacion-certificado.service";
import { PlanUsuario } from "../models/PlanesUsuario/PlanUsuario";
import { PlanUsuarioService } from "./planUsuario.service";
import { DatePipe } from "@angular/common";
import { ModalsRegularizacionComponent } from "../components/layout/modals-regularizacion/modals-regularizacion.component";
import { AuthService } from "../modules/auth";
import { PagoUsuarioService } from "./pago-usuario.service";
import { UsuarioService } from "./usuario.service";
import { DatosFacturacionService } from "./datos-facturacion-service";
import { ModalCommunicationService } from "./payment-modals-communication-service.service";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { SessionUser } from "../shared/models/sessionUser";

@Injectable({
	providedIn: "root",
})
export class ChangeCompanyService {
	companyChanged = new Subject<Emisor>();
	private planChangedSubject = new ReplaySubject<PlanUsuario>(1);
	planChanged$ = this.planChangedSubject.asObservable();

	private modalPagoPlanTemplate!: TemplateRef<any>;
	private modalChangeCompanyTemplate!: TemplateRef<any>;
	public user: SessionUser;
	private modalRefPago!: NgbModalRef;
	private modalRefChangeCompany!: NgbModalRef;
	public hasReseller: boolean;

	constructor(
		private router: Router,
		private validadorCertificadoService: VerificacionCertificadoService,
		private localStorage: LocalStorageService,
		private tokenService: TokenStorageService,
		private emisorService: EmisorService,
		private notifications: NotificationService,
		private planUsuarioService: PlanUsuarioService,
		private authService: AuthService,
		public datosFacturacionServicce: DatosFacturacionService,
		private modalCommunicationService: ModalCommunicationService,
		private datePipe: DatePipe,
		public modalService: NgbModal
	) {}

	notifyPlanChanged(plan: PlanUsuario): void {
		this.planChangedSubject.next(plan);
	  }

	SetNewCompany(currentEmisorObject: Emisor, currentSucursalId: string): void {
		Swal.fire({
			title: "Cambio de Empresa",
			icon: "info",
			html: "<h5>Ahora opera en " + currentEmisorObject.razonSocial + "</h5>",
			showCloseButton: false,
			showCancelButton: false,
			focusConfirm: true,
			confirmButtonText: '<i class="fa fa-thumbs-up"></i> Entendido',
			customClass: {
				confirmButton: "btn btn-success",
			},
		}).then((result) => {
			RoleGuard.reload$.next();
			let currentUrl = this.router.url;
			let previousUrl = this.router.routerState.snapshot.url;
			this.router.navigateByUrl("/wait-route", { skipLocationChange: true }).then(() => {
				this.user = this.tokenService.getUser() as SessionUser;
				let emisoresSource = JSON.parse(this.localStorage.getEmisores()) as Emisor[];

				this.planUsuarioService.getPlanesByCompany(currentEmisorObject.emisorId).subscribe((planes) => {
					this.user.planes = planes;
					let plan = this.verifyAlertPayment(this.user.planes, emisoresSource.length);
					this.notifyPlanChanged(plan);
					if(plan != null && plan.activo && plan.diasDiferencia > -29)
					{
						this.router.navigateByUrl(currentUrl);
					}
					else {
						this.router.navigateByUrl("/inicio");
					}
				});
			});
			this.emisorService.setActualBranchOffice(currentSucursalId, this.tokenService.getUser().id).subscribe((res) => {
				if (res.data == false) {
					Swal.fire({
						icon: "error",
						title: "Certificado Digital Vencido",
						text: "No tienes un certificado digital vigente. Por favor, actualizalo en el mantenedor de Certificados para habilitar la emisión documentos.",
						confirmButtonText: "Ok",
					}).then((result) => {
						this.tokenService.setCertificadoIsVigente(false);
						this.router.navigateByUrl("configuracion/certificados");
					});
				} else {
					this.tokenService.setCertificadoIsVigente(true);
				}
			});
			this.emisorService.getAdicionales(currentEmisorObject.emisorId).subscribe((res) => {
				this.localStorage.saveAdicionales(res);
			});
		});
		this.notifications.hubStopConnections();
		
		this.companyChanged.next(currentEmisorObject);
	}

	setModalPagoPlanTemplate(template: TemplateRef<any>) {
		this.modalPagoPlanTemplate = template;
	}

	setModalChangeCompanyTemplate(template: TemplateRef<any>) {
		this.modalChangeCompanyTemplate = template;
	}

	showModalSelectorEmpresa(showCloseButton: boolean) {

		this.modalCommunicationService.emitirCargarDatos();
		this.modalRefChangeCompany = this.modalService.open(this.modalChangeCompanyTemplate, {
			keyboard: showCloseButton,
			backdrop: showCloseButton ? true : "static",
		});
	}

	showModalPagoPlan() {
		if (!this.modalPagoPlanTemplate) {
			throw new Error("Modal template for payment plan is not set.");
		}
		this.modalCommunicationService.emitirCargarDatos();
		this.modalRefPago = this.modalService.open(this.modalPagoPlanTemplate, {
			windowClass: "",
			size: "xl",
			backdrop: "static",
			keyboard: false,
		});
	}

	cerrarModalPago() {
		this.modalRefPago.close();
	}
	cerrarModalCambiarEmpresa() {
		this.modalRefChangeCompany.close();
	}

	verifyAlertPayment(planes: Array<PlanUsuario>, emisoresCount: number): PlanUsuario {
		let planActual: PlanUsuario;
		for (let i = planes.length - 1; i >= 0; i--) {
			if (planes[i].emisorId === this.tokenService.getCompany()) {
				planActual = planes[i];
				break;
			}
		}
		this.user = this.tokenService.getUser() as SessionUser;
		this.hasReseller = this.tokenService.userHasReseller();
		if (planActual == undefined) {
			//Ningún plan vigente para esta empresa. Verifico si es primera vez que ingresa.
			if (planes.every((x) => x.emisorId == null)) {
				const mensaje = "No tienes un plan vigente. Contacta con Area Comercial";
				Swal.fire({
					icon: "error",
					title: "Acceso bloqueado",
					allowOutsideClick: false,
					allowEscapeKey: false,
					text: mensaje,
					confirmButtonText: "Salir",
				}).then((result) => {
					this.authService.logout();
				});
			} else planActual = planes[0];
		} else if (planActual.diasDiferencia < -15 || (planActual.formaPago == "free" && planActual.pagado == false && planActual.diasDiferencia < 0)) {
			if (this.hasReseller && this.user.id !== planActual.usuarioId) return;
			const mostrarBotonRegularizar = !(this.hasReseller && this.user.id == planActual.usuarioId);
			const mensaje = planActual.diasDiferencia < -15 ? "Tienes un plan en mora y ya han pasado los 15 días de espera. Favor regulariza tu situación si deseas continuar con nosotros" : "Tu plan venció el " + this.datePipe.transform(planActual.fechaCaducidad, "dd/MM/yyyy") + ". Para continuar usando SimpleFactura favor regulariza tu situación";
			Swal.fire({
				icon: "error",
				title: "Acceso bloqueado",
				allowOutsideClick: false,
				allowEscapeKey: false,
				text: mensaje,
				showCancelButton: emisoresCount > 1,
				cancelButtonText: "Cambiar de empresa",
				showConfirmButton: mostrarBotonRegularizar,
				confirmButtonText: "Regularizar",
			}).then((result) => {
				if (result.isConfirmed) {
					this.showModalPagoPlan();
				} else if (result.isDismissed) {
					this.showModalSelectorEmpresa(false);
				}
			});
		} else if (planActual.diasDiferencia < 0 && planActual.isDemo) {
			const fechaActual = new Date();
			Swal.fire({
				icon: "error",
				title: "Acceso bloqueado",
				allowOutsideClick: false,
				allowEscapeKey: false,
				text: "Ya ha terminado tu período de evaluación gratuita. Para continuar usando SimpleFactura debes adquirir un plan",
				confirmButtonText: "Regularizar",
			}).then((result) => {
				if (result.isConfirmed) {
					this.showModalPagoPlan();
				} else if (result.isDismissed) {
					this.authService.logout();
				}
			});
		} else if (planActual.diasDiferencia < 0) {
			if (this.hasReseller && this.user.id !== planActual.usuarioId) return;
			const fechaActual = new Date();
			const fechaVencimiento = new Date();
			fechaVencimiento.setDate(fechaActual.getDate() + planActual.diasDiferencia + 15);
			Swal.fire({
				icon: "error",
				title: "Necesitamos tu atención",
				allowOutsideClick: false,
				allowEscapeKey: false,
				text: "Tienes un plan en mora. Favor regularizar para evitar bloqueo. Fecha estimada de suspensión: " + this.datePipe.transform(fechaVencimiento, "dd/MM/yyyy"),
			});
		}
		return planActual;
	}
}
